import ActionTypes from '../constants/Action-Types'
import HomepageDispatcher from '../dispatcher/dispatcher'
import Store from './Store'
import * as PCLNAnalytics from '../utils/PCLN-Analytics'

class HotelFormState extends Store {
  constructor () {
    super()

    this.forms = {
      'collections-hotels': {
        visible: false
      },
      'sopq-hotels': {
        visible: false
      },
      'vip-hotels': {
        visible: false
      }
    }
  }

  toggleVisibility (formId, makeVisible) {
    const isVisible = typeof makeVisible === 'boolean' ? makeVisible : !this.forms[formId].visible
    this.forms[formId].visible = isVisible
    const action = 'Feature Box CTA'
    const eventLabelData = formId === 'sopq-hotels' ? 'Hotel SOPQ Search'
      : formId === 'collections-hotels' ? 'Hotel Collection Search'
        : formId === 'vip-hotels' ? 'Search VIP Deals' : ''

    if (isVisible) {
      PCLNAnalytics.send({
        action,
        data: eventLabelData
      })
    }

    this.emitChange()
  }

  isVisible (formId) {
    return this.forms[formId].visible
  }
}

HomepageDispatcher.register(action => {
  if (action.type === ActionTypes.TOGGLE_SEARCH_FORM) {
    HOTEL_FORM_STATE.toggleVisibility(action.form, action.open)
  }
})

const HOTEL_FORM_STATE = new HotelFormState()

export default HOTEL_FORM_STATE
